import React from "react";
import { GoAlertFill } from "react-icons/go";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <main>
      <div className="error-container" style={{ textAlign: "center", padding: "2rem" }}>
      <h1>ERROR {<GoAlertFill color="#ffaa00" style={{marginBottom:-3}} />}</h1>        <div style={{ marginBottom: "2rem" }}>
          <p style={{ fontSize: "1.2rem", marginBottom: "1.5rem" }}>
            Erro 404 page not found
          </p>
        </div>
        <Link
          to="/"
          className="button-primary"
        >
          Voltar para o início
        </Link>
      </div>
    </main>
  );
};

export default ErrorPage;
